import { jsx as _jsx } from "react/jsx-runtime";
import { CaptureEvidenceAsk } from '../AiAssist';
import { PursuitSectionOutlet } from './PursuitSectionOutlet';
import { PURSUIT_SECTION_SLUGS } from './pursuitSections';
// Route elements, not list children: no key, so moving between sections keeps
// the evidence-ask region (same element type at the same position).
function sectionElement(slug) {
    return /*#__PURE__*/ _jsx(CaptureEvidenceAsk, {
        children: /*#__PURE__*/ _jsx(PursuitSectionOutlet, {
            slug: slug
        })
    });
}
/**
 * The `/capture/:id` children (GRW-15): the index plus one route per §3.3
 * slug, `customer/themes` before `customer`.
 */ export function pursuitSectionRoutes() {
    return PURSUIT_SECTION_SLUGS.map((slug)=>slug === '' ? {
            index: true,
            element: sectionElement(slug)
        } : {
            path: slug,
            element: sectionElement(slug)
        });
}
